import { apis } from './../models/request-settings';
import { HttpRequestSettings } from '@sb-shared/models/request-settings';
import { HttpWebApiService } from '@sb-shared/services/http-web-api.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  config: HttpRequestSettings = {
    api: apis.Web
  }
  urlBase = 'WebReports/';

  constructor(private http: HttpWebApiService) { }

  getAvailableReports(displayArea: number) {
    return this.http.get(this.urlBase + 'GetAvailableReports',
      { ...this.config, params: { displayArea } });
  }

  getReportConfig(reportId: number) {
    return this.http.get(this.urlBase + 'GetReport',
      { ...this.config, params: { ReportId: reportId } });
  }
}
